import React, {Fragment} from 'react';

import {AlertTitle, Divider, Stack, Typography} from '@mui/material';
import {AlertInfo} from 'presentation/components/AlertInfo';

import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {LoadingState} from './components/LoadingState';
import {CustomStyledCardContainer, StyledFileName} from './styles';
import {AttachmentsProps} from './types';
import {UploadFiles} from './UploadFiles';

const {attachment: title} = translations['pt-br'].commons;

const {attachmentsUnavailable} = translations['pt-br'].privateFlow.myAppointments.attachments;

export const Attachments = ({
	files,
	attendanceId,
	loading,
	showUpload,
	onUploadSuccess,
	acceptAttachment,
}: AttachmentsProps) => {
	const {isMobile} = useMediaQueries();

	const hasAttachments = !loading && files;

	return (
		<CustomStyledCardContainer>
			<Typography fontWeight={600} variant="subtitle2" color="text.secondary">
				{title}
			</Typography>

			{loading ? <LoadingState /> : null}

			{!acceptAttachment && !loading ? (
				<AlertInfo.Root severity="info" sx={{padding: '14px 16px'}}>
					<AlertTitle sx={{fontWeight: 600, mb: 0.5}}>
						{attachmentsUnavailable.title}
					</AlertTitle>
					<AlertInfo.Description>
						{attachmentsUnavailable.description}
					</AlertInfo.Description>
				</AlertInfo.Root>
			) : null}

			{hasAttachments && acceptAttachment ? (
				<Fragment>
					{files.map((file, index) => (
						<Stack key={file.id} gap={2}>
							<Stack
								direction="row"
								alignItems="center"
								justifyContent="space-between"
								gap={1}>
								<StyledFileName variant="body1">{file.name}</StyledFileName>
							</Stack>
							{index < files.length - 1 ? <Divider /> : null}
						</Stack>
					))}

					{files.length > 0 && <Divider />}
					{showUpload && (
						<Stack gap={isMobile ? 2 : 1} sx={{borderRadius: isMobile ? 0 : 1}}>
							<UploadFiles
								attendanceId={attendanceId}
								onUploadSuccess={onUploadSuccess}
							/>
						</Stack>
					)}
				</Fragment>
			) : null}
		</CustomStyledCardContainer>
	);
};
